import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const OnboardingLayout = lazy(() => import('~/features/onboarding/pages/onboarding-layout'));

export const Route = createFileRoute('/_authenticated/_tenant/onboarding')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <OnboardingLayout />
    </Suspense>
  ),
});
